import React from 'react'
import {Link} from 'react-router-dom'
import {Container, Menu, MenuMenu, Dropdown, DropdownItem, DropdownMenu} from 'semantic-ui-react'
import {useAuth} from '../context/AuthContext'

function Navbar() {
  const {getUser, userIsAuthenticated, userLogout} = useAuth()

  const logout = () => {
    userLogout()
  }

  const enterMenuStyle = () => {
    return userIsAuthenticated() ? {"display": "none"} : {"display": "block"}
  }

  const logoutMenuStyle = () => {
    return userIsAuthenticated() ? {"display": "block"} : {"display": "none"}
  }

  const adminPageStyle = () => {
    const user = getUser()
    return user && user.role === 'ADMIN' ? {"display": "block"} : {"display": "none"}
  }

  const userPageStyle = () => {
    const user = getUser()
    return user && user.role === 'USER' ? {"display": "block"} : {"display": "none"}
  }

  const getUserName = () => {
    const user = getUser()
    return user ? user.name : ''
  }

  return (
    <Menu inverted color='blue' stackable size='massive' style={{borderRadius: 0}}>
      <Container>

        <MenuMenu style={logoutMenuStyle()}>
          <Dropdown color='blue' item text={`В Путь`}>
            <DropdownMenu>
              <DropdownItem as={Link} exact='true' to="/">Главная</DropdownItem>
              <DropdownItem as={Link} to="/adminpage" style={adminPageStyle()}>Админка</DropdownItem>
              <DropdownItem as={Link} to="/createreport" style={userPageStyle()}>Оставить Отчёт</DropdownItem>
              <DropdownItem as={Link} to="/searchreports" style={userPageStyle()}>Отчёты</DropdownItem>
              <DropdownItem as={Link} to="/createtrip" style={userPageStyle()}>Создать Поездку</DropdownItem>
              <DropdownItem as={Link} to="/trips" style={userPageStyle()}>Поездки</DropdownItem>
              <DropdownItem as={Link} to="/about">Полезная Информация</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </MenuMenu>

        <MenuMenu position='left' style={enterMenuStyle()}>
          <Dropdown color='blue' item text='Меню'>
            <DropdownMenu>
              <DropdownItem as={Link} to="/" style={enterMenuStyle()}>Главная</DropdownItem>
              <DropdownItem as={Link} to="/login" style={enterMenuStyle()}>Войти</DropdownItem>
              <DropdownItem as={Link} to="/signup" style={enterMenuStyle()}>Зарегистрироваться</DropdownItem>
              <DropdownItem as={Link} to="/about" style={enterMenuStyle()}>Полезная Информация</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </MenuMenu>

        <MenuMenu style={logoutMenuStyle()}>
          <Dropdown color='blue' item text={`${getUserName()}`}>
            <DropdownMenu>
              <DropdownItem as={Link} to="/mytrips" style={userPageStyle()}>Мои Поездки</DropdownItem>
              <DropdownItem as={Link} to="/inbox" style={userPageStyle()}>Входящие</DropdownItem>
              <DropdownItem as={Link} to="/profile" style={userPageStyle()}>Профиль</DropdownItem>
              <DropdownItem as={Link} to="/" onClick={logout}>Выйти</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </MenuMenu>
      </Container>
    </Menu>
  )
}

export default Navbar
